import { TransformStyleEnum } from '../enums/TransformStyleEnum'

export type PaddingType = {
  paddingTop: number
  paddingRight: number
  paddingBottom: number
  paddingLeft: number
}

export type MarginType = {
  marginTop: number
  marginRight: number
  marginBottom: number
  marginLeft: number
}

export type HoverTransformType = {
  transform?: TransformStyleEnum
  offset?: number
}

export type HoverType = {
  textColor?: string
  backgroundColor?: string
  subTextColor?: string
  transform?: TransformStyleEnum
  offset?: number
}

export type BorderWidthType = number

export type BorderRadiusType = number

export type FullBorderRadiusType = {
  borderTopLeftRadius: number
  borderTopRightRadius: number
  borderBottomRightRadius: number
  borderBottomLeftRadius: number
}

export enum BorderTypeEnum {
  fullBorder = 'fullBorder',
  bottomOnly = 'bottomOnly',
  topOnly = 'topOnly',
  topAndBottom = 'topAndBottom',
}

export type TextAlign = AlignType | 'justify'

export type AlignType = 'left' | 'center' | 'right'

export type JustifyContentType =
  | 'left'
  | 'center'
  | 'right'
  | 'flex-start'
  | 'flex-end'
  | 'space-between'
  | 'space-around'

export enum BorderStyleEnum {
  none = 'none',
  dotted = 'dotted',
  dashed = 'dashed',
  solid = 'solid',
}

export type BorderType = {
  width: BorderWidthType
  style: BorderStyleEnum
  radius: BorderRadiusType | FullBorderRadiusType
  color: string
  type?: BorderTypeEnum
}

export type AlignSelfType = 'flex-start' | 'center' | 'flex-end'

export enum ContentWidthEnum {
  xs = 'xs',
  s = 's',
  m = 'm',
  l = 'l',
  xl = 'xl',
}
